export const ordinalNumber = {
  key: 'ordinalNumber',
  label: 'No.',
  tdClass: 'border-right',
};
